/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { BotKindEnumType } from './BotKindEnum'
import { GameSnapshotModel, GameSnapshotModelType } from './GameSnapshotModel'
import { GameSnapshotModelSelector } from './GameSnapshotModel.base'
import { PlayerKindEnumType } from './PlayerKindEnum'
import { RootStoreType } from './index'

/**
 * PlayerBase
 * auto generated base class for the model PlayerModel.
 */
export const PlayerModelBase = ModelBase.named('Player')
  .props({
    __typename: types.optional(types.literal('Player'), 'Player'),
    _id: types.identifier,
    botKind: types.union(types.undefined, BotKindEnumType),
    cards: types.union(types.undefined, types.array(types.string)),
    chips: types.union(types.undefined, types.number),
    createdAt: types.union(types.undefined, types.frozen()),
    gameId: types.union(
      types.undefined,
      types.late(() => GameSnapshotModel)
    ),
    id: types.union(types.undefined, types.string),
    kind: types.union(types.undefined, PlayerKindEnumType),
    name: types.union(types.undefined, types.string),
    state: types.union(types.undefined, types.frozen()),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get botKind() {
    return this.__attr('botKind')
  }
  get cards() {
    return this.__attr('cards')
  }
  get chips() {
    return this.__attr('chips')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get id() {
    return this.__attr('id')
  }
  get kind() {
    return this.__attr('kind')
  }
  get name() {
    return this.__attr('name')
  }
  get state() {
    return this.__attr('state')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
  gameId(
    builder:
      | string
      | GameSnapshotModelSelector
      | ((selector: GameSnapshotModelSelector) => GameSnapshotModelSelector)
      | undefined
  ) {
    return this.__child('gameId', GameSnapshotModelSelector, builder)
  }
}
export function selectFromPlayer() {
  return new PlayerModelSelector()
}

export const playerModelPrimitives =
  selectFromPlayer()._id.botKind.cards.chips.createdAt.kind.name.state.updatedAt.userId
